import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";

import TabsAndInputSearchBox from "@/components/SearchAndResultShared/TabsAndInputSearchBox";
import DescriptionBlock from "@/app/pages/businessDirectory/description/Description";
import PopularCompanies from "@/app/pages/businessDirectory/PopularCompanies";
import Overlay from "@/components/overlay";
import Breadcrumb from "@/components/breadCrumb";
import {ContactDirectoryIndustryBrowseFragment} from "@/app/pages/businessDirectory/ContactDirectoryIndustryBrowseFragment"
import { getIndustries } from "@/services/businessDirectory";
import { businessDirectoryLandingPageRoutes } from "@/app/router/routes";
import { AppContext, ContextType } from "@/shared/context";
import { setDigitalData } from "@/services/setDigitalData";
import { dnbComLog, LogSeverity } from "@/shared/FunctionCore";
import { industryNotFoundErrorMessage } from "@/shared/constant";

const isContactDirectoryLandingPageAndNotSearchOverlay = false;

const LandingPage = (businessDirectoryProps) => {
	const { isUnitedStates, isEuBd } = useContext(AppContext) as ContextType
  const [industryNotFoundError, setIndustryNotFoundError] = useState(false)
  const { countryCode, singlePageSearchData } = businessDirectoryProps;
  const { t } = useTranslation();
  const [contactDirectoryIndustryData, setContactDirectoryIndustryData] = useState([])
  const [isBusinessDirectoryLandingPage, setIsBusinessDirectoryLandingPage] = useState<boolean>(false);

  useEffect(() => {
    const location = window.location;
    const {search} = location;
    const urlParams = new URLSearchParams(search);
    if (urlParams.has('errorMessage') && urlParams.get('errorMessage') === industryNotFoundErrorMessage) {
      setIndustryNotFoundError(true)
    }
    const isBDLandingPage = businessDirectoryLandingPageRoutes.includes(singlePageSearchData?.currentPagePath)
    setIsBusinessDirectoryLandingPage(isBDLandingPage)

    if (isUnitedStates) {
      setDigitalData({gcpPageName: 'businessDirectoryPage'});
      const getIndustryData = async () => {
        try {
          const data = await getIndustries();

          if (data) {
            const arr = data?.data?.industries;
            const resultData: any = Object.values(arr)
            const res: any = { industryTitleUrlRewritten: resultData }
            setContactDirectoryIndustryData(res)
          }
        }
        catch (error) {
          dnbComLog(LogSeverity.ERROR, error);
        }
      }
      getIndustryData();
    }
  }, [isUnitedStates, singlePageSearchData.currentPagePath])

  const BDTabsandInputProps = {...businessDirectoryProps, isBusinessDirectoryLandingPage}

  const breadcrumbs = [
    { name: t("homeLabel"), url: t("homeRedirection"), useAnchorTag: true },
    { name: t("business_directory"), url: t("bdLandingPageRedirectionLink")}
  ];

  // const isEuBd = ["de", "at", "ch", "hu", "pl"].includes(businessDirectoryProps?.countryCode);

  return (
    <>
      <Helmet>
        <title>{t("businessDirectory.bdBrowserTabTitle")}</title>
      </Helmet>
      <div className="outerWrapper isBusinessDirectoryLandingPageOrContactDirectoryLandingPageOrErrorPage-true  isBusinessDirectoryLandingPageAndNotSearchOverlay-true isErrorPageAndNotSearchOverlay-false isSearchOverlay-false trans-overlay">
        {isUnitedStates ? (
          <></>
        ) : (
          <div
            className={
              `heading isContactDirectoryLandingPageAndNotSearchOverlay-${isContactDirectoryLandingPageAndNotSearchOverlay}`
            }>
            {isContactDirectoryLandingPageAndNotSearchOverlay ? (
              <></>
            ) : (
              <div className="headingImageAndTextWrapper">
                <div className="headingImage isBusinessDirectoryLandingPage-true" />
                <div className="headingText">
                  {t("businessDirectory.DandBbusinessDirectory")}
                  {/* {isBusinessDirectoryLandingPageAndNotSearchOverlay
                    ? singlePageSearchData.dandbBusinessDirectoryLocalized ?? "D&B Business Directory"
                    : singlePageSearchData.searchthedunandbradstreetcloudLocalized ??
                    "Search the Dun & Bradstreet Cloud"} */}
                </div>
              </div>
            )}
            {/* 
            {businessDirectoryProps.isSearchOverlay && (
              <button
                aria-label="Close"
                className="headingSearchOverlayCloseButton"
                onClick={() => {
                  if (isNotUndefined(setIsSearchOverlayOpen)) {
                    setIsSearchOverlayOpen(false);
                  }
                }}
                type="button"
              />
            )} */}
          </div>
        )}
        <TabsAndInputSearchBox  {...BDTabsandInputProps} />
      </div>
      {industryNotFoundError && <div className="error-container">
        <p className="error-message" >We're sorry, we can't find that page right now. Search for a single company above or find a list of companies in a specific industry using our industry directory below.</p>
      </div>}
      <div className="bd-landing-content">
    <Breadcrumb
      breadcrumbs={breadcrumbs}
      forComponent="businessDirectory"
      delimiter=">"
      styling="font-style-light"
    />
      <DescriptionBlock countryCode={businessDirectoryProps.countryCode} />
      {(countryCode === 'ch' || countryCode === 'us') &&
          <PopularCompanies
          countryCode={businessDirectoryProps.countryCode}
          languageCode={businessDirectoryProps.languageCode}
        />
      }
      {}
     {!isEuBd && <ContactDirectoryIndustryBrowseFragment
        contactDirectoryIndustryData={contactDirectoryIndustryData}
        headerTextLabel={t("industries.mainHeaderTitle")}
      />}
      </div>
      <Overlay
        countryCode={countryCode}
        isEmailDisplay={['pl', 'us'].includes(countryCode)}
        isPhoneDisplay={['de', 'at', 'ch','hu','us'].includes(countryCode)}
        isRecaptchaDisplay={['de','at','ch','hu','pl','us'].includes(countryCode)}
        recaptchaActionName={t("businessDirectory.recaptchActionName")}
      />
    </>
  )
};

export default LandingPage